export enum Feature {
  BUYSPACES_MODULE = "BUYSPACES_MODULE",
  CUSTOM_FIELDS_MODULE = "CUSTOM_FIELDS_MODULE",
  GOAL_MODULE = "GOAL_MODULE",
  SUPPLIER_QUESTIONNAIRES = "SUPPLIER_QUESTIONNAIRES",
  TEST_FEATURE = "TEST_FEATURE",
  TEST_FEATURE_DISABLED = "TEST_FEATURE_DISABLED"
}
